import { SimpleLocationDto } from '@/lib/locations/dto';

import { ContactOptions } from '../types';
import { DefaultForm } from './DefaultForm';
import { LandlordForm } from './LandlordForm';
import { MeetingForm } from './MeetingForm';
import { WorkspaceForm } from './WorkspaceForm';

type FormFactoryProps = {
  option: ContactOptions;
  allLocations: SimpleLocationDto[];
};

export function FormFactory({ option, allLocations }: FormFactoryProps) {
  if (option === ContactOptions.Workspace) {
    return <WorkspaceForm allLocations={allLocations} />;
  }

  if (option === ContactOptions.RealEstate) {
    return <LandlordForm />;
  }

  if (option === ContactOptions.MeetingRoom) {
    return <MeetingForm allLocations={allLocations} />;
  }

  return <DefaultForm option={option} />;
}
